module.exports = __webpack_public_path__ + "static/media/1 09 skjelven.14b9a45e.mp3";